import { isNil, path } from 'ramda';
import dayjs, { Dayjs } from 'dayjs';

import { formatByLocale } from './date';
import { displayNumber } from './misc';
import { DutyCode, DutyCodeFlag } from 'generated/index';

export const nestedFieldValueGetter = <F extends string, R>(
  field: F,
  row: R
) => {
  return path(field.split('.'), row);
};

export const booleanValueGetterByValue = <
  V extends DutyCodeFlag,
  R extends DutyCode
>(
  value: V,
  row: R
): boolean => {
  return !!row.flags?.includes(value);
};

export const booleanValueGetterByField = (
  field: string,
  row: { flags?: string[]; [key: string]: any }
): boolean => {
  return !!row.flags?.includes(field);
};

export const numberFormatter = <V extends number>(value: V): string => {
  return displayNumber(value);
};

export const dateFormatter = (
  value: Date | Dayjs | string | undefined
): string => {
  if (isNil(value) || !dayjs(value).isValid()) return '';
  return formatByLocale(dayjs(value).toDate());
};
export const timeFormatter = (
  value: Date | Dayjs | string
): string | undefined => {
  if (isNil(value) || !dayjs(value).isValid()) return;
  return dayjs(value).format('HH:mm');
};

export const dateAndTimeFormatter = (
  value: Date | Dayjs | string
): string | undefined => {
  if (isNil(value) || !dayjs(value).isValid()) return;
  return dayjs(value).format('DD-MM-YYYY HH:mm');
};

export const fullDateFormatter = (
  value: Date | Dayjs | string
): string | undefined => {
  if (isNil(value)) return;
  return formatByLocale(dayjs(value).toDate(), 'dd MMMM yyyy');
};

export const defaultDateFormatter = (
  value: Date | Dayjs | string
): string | undefined => {
  if (isNil(value) || !dayjs(value).isValid()) return;

  return dayjs(value).format('DD-MM-YYYY');
};
